import { json } from "react-router-dom";
import { BASE_CHATURL, BASE_FILEURL, BASE_URL } from "../components/constants";
import { v4 as uuidV4 } from "uuid";
import { authHeader } from '../utils/authHeaders';

export function postChatHistory(data) {
  const { user_id, task_id, history_id, tname } = data;
  const url = `${BASE_CHATURL}/chat-history`;
  const body = { user_id, task_id, history_id, tname };
  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
    body: JSON.stringify(body),
  })
  .then(response => {

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  })
  
  .catch(error => {
    console.error('Error posting chat history:', error);
    throw error;
  });
}

export async function uploadFilesWithHistory(files, userId, taskId, historyId, page_counts) {
  const formData = new FormData();
  files.forEach(file => {
    formData.append('files', file);
  });
  formData.append('user_id', userId);
  formData.append('task_id', taskId ? String(taskId) : "");
  formData.append('history_id', historyId);
  formData.append('page_counts', page_counts.join(','));

  try {
    const response = await fetch(`${BASE_URL}/uploader`, {
      method: 'POST',
      headers: { ...authHeader() },
      body: formData,
    });
    
    
    if (!response.ok) {
      // Try to get detailed error message from response
      const errorData = await response.json().catch(() => null);
      const detail = errorData?.detail;
      if (detail && typeof detail === 'object' && detail.code) {
        // Structured, language-neutral error (e.g. the per-session page
        // limit) — callers translate it via `error.code`, same as
        // createChatHistory below, instead of showing a server-formatted
        // sentence that would bypass i18n.
        const err = new Error(detail.code);
        err.code = detail.code;
        err.limit = detail.limit;
        err.attempted = detail.attempted;
        throw err;
      }
      throw new Error(detail || `Upload failed with status: ${response.status}`);
    }

    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error('Error uploading files:', error);
    throw error; // Re-throw to allow caller to handle the error
  }
}

export async function  createChatHistory(userId, taskId, historyId = uuidV4(), tname = "", history_name = "Chat", type = "chat") {
  let finalHistoryId = historyId;
  if (!finalHistoryId) {
    finalHistoryId = uuidV4();
  }
  return fetch(`${BASE_CHATURL}/chat-history`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
    body: JSON.stringify({
      user_id: userId,
      task_id: taskId,
      history_id: finalHistoryId,
      task_name: tname || "",
      history_name: history_name || "Chat",
    }),
  })
  .then(async response => {
    if (!response.ok) {
      const errorData = await response.json();
      const detail = errorData?.detail;
      if (detail && typeof detail === 'object' && detail.code) {
        // Structured, language-neutral error (e.g. history limit reached) -
        // callers translate this via `error.code`/`error.limit` instead of
        // showing `error.message` raw, which would bypass i18n entirely.
        const err = new Error(detail.message || detail.code);
        err.code = detail.code;
        err.limit = detail.limit;
        throw err;
      } else if (detail) {
        throw new Error(detail);
      } else {
        throw new Error(`HTTP error! status: ${response.status}, details: ${JSON.stringify(errorData)}`);
      }
    }
    return await response.json();
  });
}



export async function updateHistoryName(historyId, newName) {
  try {
    const response = await fetch(`${BASE_CHATURL}/update-history-name/${historyId}?new_name=${encodeURIComponent(newName)}`, {
      method: 'PUT',
      headers: { ...authHeader() },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error updating chat history name:', error);
    throw error;
  }
}

export async function deleteHistory(historyId) {
  try {
    const response = await fetch(`${BASE_URL}/history/${historyId}`, {
      method: 'DELETE',
      headers: { ...authHeader() },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  } catch (error) {
    console.error('Error deleting chat history:', error);
    throw error;
  }
}
